import React from 'react';
import PropTypes from 'prop-types';

var Trigger = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    onClick = _ref.onClick,
    disabled = _ref.disabled,
    className = _ref.className;
  return /*#__PURE__*/React.cloneElement(children, {
    ref: ref,
    onClick: onClick,
    disabled: disabled,
    className: className
  });
});
Trigger.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  disabled: PropTypes.bool,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func
};
Trigger.defaultProps = {
  disabled: false
};

export { Trigger as default };
//# sourceMappingURL=Trigger.js.map
